import React, { useEffect, useState } from "react";
import { formatCoin, formatTime, getRound } from "../../utils/utils";
import "./styles.scss";
import bitConIcon from "../../assets/images/bitcoin-icon.svg";
import { useSelector } from "react-redux";
import { getContestsCarousel } from "../../redux/contests/selectors";
import ValueCoin from "./components/ValueCoin";
import { formatNumber } from "../../services/utility/utils";
import Round from "../../components/CartTicket/components/Round";


const CountDown = ({ time }) => {
  const [nextRound, setNextRound] = useState(60);
  useEffect(() => {
    const interval = setInterval(
      () => setNextRound(60 - Math.round((new Date().getTime() - new Date(time).getTime()) / 1000)),
      1000
    );
    return () => clearInterval(interval);
  }, [time]);

  return <>{formatTime(nextRound)}</>;
};


function LivePage() {
  const contestsCarousel = useSelector(getContestsCarousel);
  const coinValue = useSelector((state: any) => state?.coinPrices?.BTC || 0);

  const contest = contestsCarousel?.find((item: any) => item?.status === "Live") || contestsCarousel[0];

  const valuePrice = coinValue * 1 - contest?.livePrice;
  const count = contest?.livePrice ? Math.abs(valuePrice * Math.random() * 5) : 0;
  const increase = valuePrice > 0;
  const direction = contest?.position === "moon" ? "above" : "below";

  return (
    <>
      <div className="wrapper-content-value-bitcoin">
        <div className="content-value-bitcoin">
          <div className="bitcoin-value">
            <ValueCoin />
            <img src={bitConIcon} alt="" className="icon-coin" />
          </div>
          <div className="next-round">Next Round starts in <CountDown time={contest?.contestLiveTime} /></div>
        </div>
        <div className="content-lock-price">
          <p className="content-lock-price-label">Locked Price</p>
          <p className="content-lock-price-value">
            {contest?.livePrice > 0 ? `$${formatCoin(contest?.livePrice, 2)}` : "Loading"}
          </p>
        </div>
      </div>
      <div className="wrapper-content-page-live">

        {contest?.position && (
          <div className={`wrapper-live-bet type-${direction}`}>
            <div className={`user-position ${direction} ${increase ? 'up' : 'down'}`}>
              <p className="value-bet">${formatNumber(contest?.wager, 2, 0)}</p>
              <p className="label-bet">{direction}</p>
              <div className="bet-icon">
                <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.4922 17.625L16.1172 18L15.7422 17.625L15.7422 6.375L16.1172 6L16.4922 6.375L16.4922 17.625Z" fill="currentColor"/>
                  <path d="M1.5 17.625L1.125 18L0.75 17.625L0.749999 6.375L1.125 6L1.5 6.375L1.5 17.625Z" fill="currentColor"/>
                  <path d="M12.75 20.625L12.375 21L12 20.625L12 3.375L12.375 3L12.75 3.375L12.75 20.625Z" fill="currentColor"/>
                  <path d="M5.25 20.625L4.875 21L4.5 20.625L4.5 3.375L4.875 3L5.25 3.375L5.25 20.625Z" fill="currentColor"/>
                  <path d="M9.00781 23.625L8.63281 24L8.25781 23.625L8.25781 0.375L8.63281 3.27835e-08L9.00781 0.375L9.00781 23.625Z" fill="currentColor"/>
                  <path d="M9.75 22.9286L8.625 24L7.5 22.9286L7.5 13.8214L8.625 12.75L9.75 13.8214L9.75 22.9286Z" fill="currentColor"/>
                  <path d="M5.99219 19.9286L4.86719 21L3.74219 19.9286L3.74219 15.3214L4.86719 14.25L5.99219 15.3214L5.99219 19.9286Z" fill="currentColor"/>
                  <path d="M2.25 16.9286L1.125 18L-3.32086e-07 16.9286L-3.41453e-07 16.8214L1.125 15.75L2.25 16.8214L2.25 16.9286Z" fill="currentColor"/>
                  <path d="M13.5 19.9286L12.375 21L11.25 19.9286L11.25 12.3214L12.375 11.25L13.5 12.3214L13.5 19.9286Z" fill="currentColor"/>
                  <path d="M17.25 16.9286L16.125 18L15 16.9286L15 10.8214L16.125 9.75L17.25 10.8214L17.25 16.9286Z" fill="currentColor"/>
                </svg>
              </div>
            </div>
          </div>
        )}

        <div className="content-page-live-line">
          <div className="container page-live-line">
            <div className="vertical-line"></div>

            <div
              className={`wrapper-node-line ${
                increase ? "ticker-above" : "ticker-below"
              }`}
              style={{
                transform: `translateX(${increase ? "" : "-"}${count}px)`,
                transition: "all 0.4s",
              }}
            >
              <div className="diamond-icon"></div>
            </div>
          </div>
        </div>
        <div className="contest-odds">
          <span>{formatNumber(contest?.whitelabelRektOdds, 2, 0)}</span>
          <span>{formatNumber(contest?.whitelabelMoonOdds, 2, 0)}</span>
        </div>
        <div className="live-round">
          <p className="live-round-label">{contest?.status}</p>
          <Round content={`Round #${getRound(contest?.contestLiveTime) || ""}`} />
        </div>
      </div>
    </>
  );
}

export default LivePage;
